import React from "react";
import MaterialPaper, { PaperProps } from "@mui/material/Paper";

interface IProps extends PaperProps {
  component?: any
}

export const Paper: React.FC<IProps> = (props) => (
  <MaterialPaper {...props} />
);
